export default __webpack_public_path__ + "media/wallpaper/six-full-b53f7152.jpg";